import { useState, useEffect } from 'react';
import Sidebar from '@/UIlibrary/Sidebar/Sidebar';
import { useTranslations } from 'use-intl';
import { Book, UserPlus } from 'react-feather';
import { Outlet, useLocation } from 'react-router-dom';
import { Roles } from '@/pages/ClientProfiles/Roles.types';
import { useSupabaseAuth } from '@/pages/CustomerSupport/useSupabaseAuth';

export default function Root() {
	const t = useTranslations('Layout');
	const [currentPath, setCurrentPath] = useState('');
	const location = useLocation();
	const { isKogniUser } = useSupabaseAuth(`${Roles.CUSTOMER_SUPPORT},${Roles.KOGNI_ADMIN}`);

	useEffect(() => {
		setCurrentPath(location.pathname + location.search);
	}, [location.pathname, location.search]);

	const getLayoutStyles = () => ({
		display: 'flex',
		height: '100vh',
		overflowX: 'hidden' as const,
		position: 'fixed' as const,
		left: 0,
		right: 0,
		top: 0,
		bottom: 0
	});

	const getMainContentStyles = () => ({
		flexGrow: 1,
		display: 'flex',
		flexDirection: 'column' as const,
		minWidth: 0,
		backgroundColor: 'white',
		overflowY: 'auto' as const,
		overflowX: 'auto' as const
	});

	const getSectionGroups = {
		sections: [
			// {
			// 	name: t('Dashboard'),
			// 	icon: <Grid size={16} />,
			// 	items: [
			// 		{
			// 			name: t('MyDashboard'),
			// 			link: 'dashboard?startingTab=dashboard'
			// 		},
			// 		{
			// 			name: t('CompanyDashboard'),
			// 			link: 'dashboard?startingTab=companyDashboard'
			// 		}
			// 	],
			// 	hasDropdown: true
			// },
			{
				name: t('ClientManagement'),
				icon: <UserPlus size={16} />,
				items: [
					{
						name: t('Clients'),
						link: 'clients'
					},
					{
						name: t('BureauAuthorizations'),
						link: 'reports'
					}
				],
				hasDropdown: true
			},
			{
				name: t('CreditManagement'),
				icon: <Book size={16} />,
				items: [
					{
						name: t('Microcredits'),
						link: 'microcredit'
					},
					{
						name: t('VanCredits'),
						link: 'van-credits'
					}
					// {
					// 	name: t('NewCredits'),
					// 	link: '/new-credits'
					// },
					// {
					// 	name: t('StandingLoans'),
					// 	link: '/standing-loans'
					// },
					// {
					// 	name: t('DelinquentLoans'),
					// 	link: '/delinquent-loans'
					// }
				],
				hasDropdown: true
			}
			// {
			// 	name: t('Transactions'),
			// 	icon: <DollarSign size={16} />,
			// 	items: [
			// 		{
			// 			name: t('TotalPayments'),
			// 			link: '/tpv-loans'
			// 		},
			// 		{
			// 			name: t('TPV'),
			// 			link: '/tpv-debit'
			// 		},
			// 		{
			// 			name: t('TransactionHistory'),
			// 			link: '/transaction-history'
			// 		},
			// 		{
			// 			name: t('PaymentSuccessRate'),
			// 			link: '/payment-success-rate'
			// 		}
			// 	],
			// 	hasDropdown: true
			// }
		]
	};

	const getCustomerSupportManagementSection = {
		name: t('CustomerSupportManagement'),
		icon: <UserPlus size={16} />,
		items: [
			{
				name: t('Chats'),
				link: 'customer-support'
			},
			{
				name: t('SupportClients'),
				link: 'support-clients'
			},
			...(isKogniUser
				? [
						{
							name: t('ManageAgents'),
							link: 'manage-agents'
						},
						{
							name: t('AnalysisConfigurations'),
							link: 'analysis-configurations'
						},
						{
							name: t('ManageOrganization'),
							link: 'manage-organization'
						}
					]
				: [])
		],
		hasDropdown: true
	};

	return (
		<div style={getLayoutStyles()} id="portal-layout">
			<div style={{ height: '100%' }}>
				<Sidebar
					user={{
						firstName: 'Finclu',
						initials: 'FY'
					}}
					companyLogoURL={'/logo-white.jpg'}
					sectionGroups={getSectionGroups}
					settingsTitle={t('Settings')}
					logoutTitle={t('Logout')}
					supportTitle={t('Support')}
					customerSupportManagementSection={getCustomerSupportManagementSection}
					currentPath={currentPath}
				/>
			</div>
			<main style={getMainContentStyles()} className="custom-scrollbar">
				<Outlet />
			</main>
		</div>
	);
}
